import { useQuery } from '@tanstack/react-query';

import { getRooftopFeaturesApi } from 'api/features';
import { GetRooftopFeaturesResponseDTO } from 'declarations/dto/features';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import { ApiErrorI } from 'declarations/interfaces/errors';

export const useFetchRooftopFeatures = (rooftopId: string) =>
  useQuery<GetRooftopFeaturesResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.GetRooftopFeatures, rooftopId],
    () => getRooftopFeaturesApi(rooftopId),
    { staleTime: RequestStaleTimeE.TicketsCountByRoofTop }
  );
